import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { TiClipboard } from "react-icons/ti";
import Layout from "../Layouts/layout";
import { fetchData } from "../../../services/apiService";
import useAlertUtils from "../../../utils/common.utils";

function PatientLabTests() {
  const navigate = useNavigate();

  const [testData, setTestData] = useState([]);
  const { alertError } = useAlertUtils();

  const getTestData = async () => {
    try {
      const data = await fetchData(`api/test/get-all-labTests`);
      if (data.success === true) {
        setTestData(data.data);
      } else {
        alertError("Error Fetching Data");
      }
    } catch (error) {
      alertError("Error -> ", error);
    }
  };

  useEffect(() => {
    getTestData();
  }, []);
  return (
    <div className="appointment-page">
      <Layout>
        <div className="main_content">
          <div className="container">
            <div className="main_block">
              <div className="top_bar">
                <div className="left_part">
                  <div className="main_title">Patient Lab Tests</div>
                </div>
              </div>
              <div className="table_wrapper dashboard">
                <div className="table_inner">
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="right">First Name</TableCell>
                          <TableCell align="right">Last Name</TableCell>
                          <TableCell align="right">Email</TableCell>
                          <TableCell align="right">Test Name</TableCell>
                          <TableCell align="right">Laboratory Name</TableCell>
                          <TableCell align="right">Laboratory Location</TableCell>
                          <TableCell align="right">Added Date</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {testData &&
                          testData.map((row) => (
                            <TableRow
                              key={row?.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="right">
                                <span className="mob_head">First Name</span>
                                {row?.user?.firstName}
                              </TableCell><TableCell align="right">
                                <span className="mob_head">Last Name</span>
                                {row?.user?.lastName}
                              </TableCell><TableCell align="right">
                                <span className="mob_head">Email</span>
                                {row?.user?.email}
                              </TableCell>
                              <TableCell align="right">
                                <span className="mob_head">Test Name</span>
                                {row?.testName}
                              </TableCell>
                              <TableCell align="right">
                                <span className="mob_head">
                                  Laboratory Name
                                </span>
                                {row?.laboratoryName}
                              </TableCell>

                              <TableCell align="right">
                                <span className="mob_head">
                                  Laboratory Location
                                </span>
                                {row?.laboratoryLocation}
                              </TableCell>

                              <TableCell align="right">
                                <span className="mob_head">Added Date</span>
                                {new Date(row?.createdAt).toLocaleDateString(
                                  "en-US",
                                  {
                                    weekday: "long",
                                    month: "long",
                                    day: "numeric",
                                  }
                                )}
                              </TableCell>
                              <TableCell align="right">
                                <span className="mob_head">Action</span>
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <TiClipboard
                                    onClick={() => {
                                      navigate(
                                        `/app/patient-test-details/${row?.id}`
                                      );
                                    }}
                                    size={30}
                                    color="black"
                                    cursor="pointer"
                                  />
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default PatientLabTests;
